{
  "markread": "既読にする",
  "filter": "フィルター",
  "newest": "新着",
  "unread": "未読",
  "starred": "スター",
  "tags": "タグ",
  "alltags": "全てのタグ",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 時間},other {# 時間}}前",
  "minutes": "{0,plural,one {1 分},other {# 分}}前",
  "seconds": "{0,plural,one {1 秒},other {# 秒}}前",
  "days": "{0,plural,zero {今日},one {昨日},other {# 日前}}",
  "star": "スターをつける",
  "unstar": "スターを外す",
  "mark": "既読にする",
  "unmark": "未読にする",
  "load_img": "画像を表示",
  "open_window": "開く",
  "next": "次へ",
  "searchbutton": "検索",
  "searchremove": "検索を非表示",
  "refreshbutton": "ソースの更新",
  "settingsbutton": "設定",
  "logoutbutton": "ログアウト",
  "loginbutton": "ログイン",
  "sources": "ソース",
  "source_add": "ソースを追加",
  "source_opml": "または OPML ファイルをインポート",
  "source_export": "ソースをエクスポート",
  "source_edit": "編集",
  "source_filter": "フィルター",
  "source_delete": "削除",
  "source_warn": "このソースを削除しますか？",
  "source_new": "新しい未保存のソース",
  "source_title": "タイトル",
  "source_tags": "タグ",
  "source_pwd_placeholder": "変更されていません",
  "source_comma": "カンマ(,)区切り",
  "source_select": "ソースを選択してください",
  "source_type": "タイプ",
  "source_save": "保存",
  "source_cancel": "キャンセル",
  "source_saved": "保存されました",
  "source_last_post": "最終参照日",
  "source_refresh": "このソースを更新",
  "no_entries": "記事がありません",
  "more": "もっと見る",
  "login": "ログイン",
  "login_username": "ユーザー名",
  "login_password": "パスワード",
  "no_title": "タイトルなし",
  "error": "エラーが発生しました",
  "streamerror": "記事を読み込めませんでした。再読み込みしますか？",
  "source_autotitle_hint": "空のままにするとタイトルを取得します",
  "login_invalid_credentials": "ユーザー名/パスワードが間違っています",
  "reload_list": "一覧を再読み込み",
  "sources_refreshed": "ソースを更新しました",
  "error_session_expired": "セッションが期限切れです",
  "error_add_source": "ソースを追加できません:",
  "error_delete_source": "ソースを削除できません:",
  "error_load_tags": "タグを読み込みできません:",
  "error_unknown_tag": "不明なタグ:",
  "error_unknown_source": "不明なソースID:",
  "error_mark_items": "すべての表示項目をマークできません:",
  "error_mark_item": "項目をマーク/マーク解除できません:",
  "error_star_item": "項目をスター/スター解除できません:",
  "error_logout": "ログアウトできません:",
  "error_loading": "読み込みエラー:",
  "error_loading_stats": "NAV統計を読み込みできません:",
  "error_saving_color": "新しい色を保存できません:",
  "error_refreshing_source": "ソースを更新できません:",
  "error_sync": "サーバから最後の変更を同期できませんでした:",
  "error_invalid_subsection": "不正なサブセクション:",
  "online_count": "サーバーで利用可能な項目",
  "offline_count": "ローカルで利用可能な項目",
  "login_offline": "オフライン ストレージ",
  "app_update": "selfoss が更新されました。再読み込みしてください",
  "app_reload": "再読み込み",
  "error_offline_storage": "オフライン ストレージ エラー: {0}。 再読み込みが役立つことがあります。今のところ、オフラインを無効にします。",
  "search_label": "検索条件",
  "article_actions": "アクション",
  "error_configuration": "設定を読み込めません。",
  "info_url_copied": "URLをクリップボードにコピーしました。",
  "article_reading_time": "{0} 分 読みました",
  "source_menu": "その他のアクション",
  "source_browse": "検索",
  "source_warn_cancel_dirty": "保存されていない変更を破棄しますか？",
  "sources_leaving_unsaved_prompt": "ソースの変更を保存せずに設定を残しますか？",
  "experimental": "試験的",
  "error_check_system_logs": "エラーが発生しました。システムログを確認してください。",
  "error_edit_source": "ソースの変更を保存できませんでした：",
  "error_share_native": "アイテムを共有できません。",
  "error_share_native_abort": "アイテムを共有できません—共有先がないか、キャンセルしました。",
  "share_pocket_label": "Pocket に保存",
  "share_twitter_label": "Twitter でシェア",
  "close_entry": "閉じる",
  "share_facebook_label": "Facebook でシェア",
  "offline_navigation_unavailable": "現在、オフラインモードではタグとソースの切り替えができません。",
  "share_diaspora_label": "Diaspora でシェア",
  "share_wallabag_label": "Wallabag に保存",
  "share_copy_label": "リンクをクリップボードにコピー",
  "error_check_log_file": "エラーが発生しました。ログファイル「{0}」を確認してください。",
  "error_unwritable_logs": "ログを書き込めません。",
  "share_mail_label": "メールを使用して共有",
  "share_native_label": "共有",
  "share_wordpress_label": "WordPress でシェア",
  "error_offline_storage_not_available": "オフラインストレージは利用できません。 Webブラウザ {0} がIndexedDBAPI {1} をサポートしていること、および Google Chrome ベースのブラウザを使用している場合は、シークレットモードで selfoss を実行していないことを確認してください。",
  "share_mastodon_label": "Mastodon でシェア"
}
